//
//
//
//
//
//
//
//
//
//

export default {
    name: "my-address",
    data() {
        return {
            chosenAddressId: '1',
            list: [],
            loading: false,
        }
    },
    methods: {
        onEdit(item, index) {
            this.$router.push({
                name: 'addressEdit',
                params: {
                    id: item.id
                }
            })
        },
        onAdd() {
            this.$router.push({
                name: 'addressEdit',
                params: {
                    id: 0
                }
            })
        },
        getAddresses() {
            var memberId;
            if (localStorage.getItem('MemberId') !== undefined || localStorage.getItem('MemberId') != null) {
                memberId = parseInt(localStorage.getItem('MemberId'));
            } else {
                return
            }
            var page = {
                memberId: memberId,
                maxResultCount: 20,
                skipCount: 0
            };
            var vm = this;
            abp.ajax.post('/api/services/app/ContactInformation/SearchData', page).then(res => {
                vm.list = [];
                // console.log(vm.list.length);
                if (res.data.result.items.length > 0) {
                    res.data.result.items.forEach(a => {
                        vm.list.push({
                            id: a.id,
                            name: a.contact,
                            tel: a.contactPhone,
                            address: a.areaName + ' ' + a.contactAddress
                        });
                        if (a.isDefault) {
                            vm.chosenAddressId = a.id;
                        }
                    })
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        select(item, index) {
            // console.log('item:%@', item);
            var d = {
                contact: item.name,
                contactPhone: item.tel,
                id: parseInt(item.id),
                address: item.address
            };
            var vm = this;
            vm.$store.commit('saveOrder/setContactInfo', d);
            vm.$router.back();
        }
    },
    created() {
        this.getAddresses()
    }
}
